import { createReducer } from 'utils'
import { fromJS } from 'immutable'

import { constants } from 'common/actions/systems'
import { RESET_ERROR } from 'common/actions/error'

export const initialState = fromJS({
  isSubmitting: false,
  error: null
})

export default createReducer(initialState, {
  [RESET_ERROR]: state => state.set('error', null),

  [constants.CREATE_GROUP_REQUEST.START]: state => state.set('isSubmitting', true),
  [constants.CREATE_GROUP_REQUEST.SUCCESS]: () => initialState,
  [constants.CREATE_GROUP_REQUEST.FAILURE]: (state, { payload: error }) => {
    return state.set('isSubmitting', false).set('error', error)
  },
  [constants.DELETE_GROUP_SYSTEM_REQUEST.START]: state => state.set('isSubmitting', true),
  [constants.DELETE_GROUP_SYSTEM_REQUEST.SUCCESS]: () => initialState,
  [constants.DELETE_GROUP_SYSTEM_REQUEST.FAILURE]: (state, { payload: error }) => {
    return state.set('isSubmitting', false).set('error', error)
  }
})
